var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectAllIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Select_all",
    "data-name": "Select all",
    d: "M52,48a4,4,0,1,0,4,4A4,4,0,0,0,52,48Zm2.082,2.659L51.5,53.736a.308.308,0,0,1-.231.11h-.005a.308.308,0,0,1-.229-.1l-1.108-1.231a.308.308,0,1,1,.457-.412l.871.968,2.357-2.806a.308.308,0,1,1,.471.4Z",
    transform: "translate(-48 -48)",
    fill: "#0d0d0d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAllIcon);
export default __webpack_public_path__ + "static/media/select-all-icon.fc713b1459b96541de3e8f4cbab2b098.svg";
export { ForwardRef as ReactComponent };